import { useTranslation } from "react-i18next";
import React from "react";
import TaskList from "../components/TaskList";
import Loader from "../../../../components/Common/loader";
import { formatToFrenchDate } from "../../../../utils/dateUtils";
import NoDataComponent from "components/Common/NoData";

interface TaskListCardProps {
  selectedDate: string | null;
  tasks: any[];
  loading: boolean;
  error: string | null;
  onTaskClick: (task: any) => void;
}

const TaskListCard: React.FC<TaskListCardProps> = ({ selectedDate, tasks, loading, error, onTaskClick }) => {
  const { t } = useTranslation();
  return (
    <div>
      {loading && <Loader />}
      {error && <p className="text-danger">{error}</p>}
      {!loading && !error && (
        <TaskList tasks={tasks} onTaskClick={onTaskClick} />
      )}
    </div>
  );
};

export default TaskListCard;
